import { postApi } from 'api/cms/http'

// eslint-disable-next-line import/prefer-default-export
export const apiErrorLog = (data = {}) => {
  if (window.location.hostname !== 'bookh5.xueersibook.com') return false
  return postApi('/webapi/cicp/cms/api/log/logger', data)
}
